<div>
  <!-- Only the admin screen gets a heading here. In the member flow the reserve stepper
       is already titled "Kies een datum", and repeating it above the calendar said the
       same thing three times on one screen. -->
  @if (originIsAdminComponent) {
    <h2 class="mb-3 text-lg font-semibold text-fg">Kies een datum</h2>
  }
  @if (componentLoaded) {
    <app-calendar
      [selectableDates]="selectableDates"
      [allowAnyDate]="originIsAdminComponent"
      [minDate]="dateToday"
      [selected]="value"
      (datePicked)="onDatePicked($event)"
    />
  } @else {
    <div class="flex justify-center py-8"><app-spinner /></div>
  }
</div>
